import { deriveCache } from '../util/index.js';
export function getEraCache(CACHE_KEY, era, withActive) {
  const cacheKey = "".concat(CACHE_KEY, "-").concat(era.toString());
  return [cacheKey, withActive ? undefined : deriveCache.get(cacheKey)];
}
export function getEraMultiCache(CACHE_KEY, eras, withActive) {
  const cached = withActive ? [] : eras.map(e => deriveCache.get("".concat(CACHE_KEY, "-").concat(e.toString()))).filter(v => !!v);
  return cached;
}
export function setEraCache(cacheKey, withActive, value) {
  !withActive && deriveCache.set(cacheKey, value);
  return value;
}
export function setEraMultiCache(CACHE_KEY, withActive, values) {
  !withActive && values.forEach(v => deriveCache.set("".concat(CACHE_KEY, "-").concat(v.era.toString()), v));
  return values;
}
export function filterCachedEras(eras, cached, query) {
  return eras.map(e => cached.find(_ref => {
    let {
      era
    } = _ref;
    return e.eq(era);
  }) || query.find(_ref2 => {
    let {
      era
    } = _ref2;
    return e.eq(era);
  }));
}